import React from 'react';
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const data = [
  {
    name: 'SEPT 22',
    total: 4000,
    online: 2400,
    offline: 2400,
  },
  {
    name: 'OCT 22',
    total: 3000,
    online: 1398,
    offline: 2210,
  },
  {
    name: 'NOV 22',
    total: 9800,
    online: 4000,
    offline: 2290,
  },
  {
    name: 'DEC 22',
    total: 2780,
    online: 3908,
    offline: 2000,
  },
  {
    name: 'JAN 23',
    total: 1890,
    online: 4800,
    offline: 2181,
  },
  {
    name: 'FEB 23',
    total: 2390,
    online: 3800,
    offline: 2500,
  },
  {
    name: 'MAR 23',
    total: 3490,
    online: 4300,
    offline: 2100,
  },
];

const Bullet = ({ backgroundColor, size }) => {
  return (
    <div
      className='circle-bullet'
      style={{
        backgroundColor,
        width: size,
        height: size,
      }}
    ></div>
  );
};

const CustomizedLegend = (props) => {
  const { payload } = props;
  return (
    <div className='d-flex justify-content-end'>
      {payload.map((entry, index) => (
        <div key={`item-${index}`} className='d-flex align-items-center mx-2'>
          <Bullet backgroundColor={entry.payload.fill} size='10px' />
          <div className='ms-3'>{entry.value}</div>
        </div>
      ))}
    </div>
  );
};

const MonthlyStatusChart = () => {
  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer width='100%' height='100%'>
        <BarChart
          width={500}
          height={500}
          data={data}
          margin={{
            top: 0,
            right: 30,
            left: 20,
            bottom: 0,
          }}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey='name' />
          <YAxis />
          <Tooltip />
          <Legend content={<CustomizedLegend />} />
          <Bar dataKey='total' fill='#4791FF' barSize={10} />
          <Bar dataKey='online' fill='#02BC77' barSize={10} />
          <Bar dataKey='offline' fill='#FF2366' barSize={10} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthlyStatusChart;
